module.exports = __webpack_public_path__ + "static/media/promocode.116488ea.svg";